import { Modal, Spin } from '@arco-design/web-react'
import { useTranslation } from 'react-i18next'
import { renderQuota, displayAmountToQuota } from '@/utils/quota'
import { modalWidth } from '@/utils/responsive'
import { getMethodLabel } from './PaymentMethodPicker'

interface PaymentConfirmModalProps {
  visible: boolean
  loading: boolean
  paymentMethod: string
  amount: number
  payMoney?: string | null
  creemProductName?: string
  onConfirm: () => void
  onCancel: () => void
}

export default function PaymentConfirmModal({
  visible,
  loading,
  paymentMethod,
  amount,
  payMoney,
  creemProductName,
  onConfirm,
  onCancel,
}: PaymentConfirmModalProps) {
  const { t } = useTranslation()
  const methodLabel = getMethodLabel(paymentMethod, t)
  const quotaPreview = paymentMethod === 'creem' ? null : renderQuota(displayAmountToQuota(amount))

  return (
    <Modal
      title={t('tt.topup.confirmPay')}
      visible={visible}
      onOk={onConfirm}
      onCancel={onCancel}
      confirmLoading={loading}
      okText={t('tt.topup.confirmPayOk')}
      cancelText={t('tt.topup.cancel')}
      style={{ width: modalWidth(420) }}
    >
      <Spin loading={loading && !payMoney}>
        <div className="space-y-3 text-[14px] text-[#374151]">
          <div className="flex justify-between">
            <span className="text-[#6B7280]">{t('tt.topup.paymentMethod')}</span>
            <span className="font-medium">{methodLabel}</span>
          </div>
          {creemProductName ? (
            <div className="flex justify-between">
              <span className="text-[#6B7280]">{t('tt.topup.package')}</span>
              <span className="font-medium">{creemProductName}</span>
            </div>
          ) : (
            <>
              <div className="flex justify-between">
                <span className="text-[#6B7280]">{t('tt.topup.amount')}</span>
                <span className="font-medium">{amount}</span>
              </div>
              {payMoney && (
                <div className="flex justify-between">
                  <span className="text-[#6B7280]">{t('tt.topup.paidAmount')}</span>
                  <span className="text-[#DC2626] font-semibold">¥{payMoney}</span>
                </div>
              )}
              {quotaPreview && (
                <div className="flex justify-between">
                  <span className="text-[#6B7280]">{t('tt.topup.estimatedCredit')}</span>
                  <span className="font-medium text-brand">{quotaPreview}</span>
                </div>
              )}
            </>
          )}
        </div>
      </Spin>
    </Modal>
  )
}
